export const SUMMARY_REPORT_OBJECT_TYPE = {
    GRAPH_SCREEN: 1,
    MAP_SCREEN: 2,
    DOCUMENT_OBJECT_NODES: 3,
    CONTENT: 4,
    TABLE_ROWS: 5
};
